import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import DOMPurify from "dompurify";

const faqs = [
  {
    question:
      "1. Is the retreat suitable for someone new to Geneen’s work?",
    answer:
      "Absolutely! This retreat is designed for everyone—whether you're brand new to Geneen’s teachings or deeply familiar with them. You’ll feel right at home, and everything will be fully accessible and welcoming.",
  },
  {
    question: 
      "2. Do I need to prepare before the retreat?",
    answer:
      "It’s a good idea to read Women, Food, and God and her new book, LOVE, FINALLY (available 4.21.26), as preparation for your retreat. If you haven’t read them yet, then don’t worry! Any of Geneen’s books can be a helpful companion.",
  },
  {
    question: 
      "3. What if I can’t attend all the live sessions?",
    answer:
      "We encourage you to join us live to get the most out of the experience, but we understand that life can be unpredictable. That's why every session is recorded and made available to you online. You won’t miss a thing, and you can watch at your convenience!",
  },
  {
    question: 
      "4. What is your cancellation policy?",
    answer: 
      `The deposit is non-refundable. If you cancel before September 19, 2026, you will be refunded the tuition paid (less deposit and any credit card fees paid). After September 19, 2026, the full tuition is non-refundable and non-transferable. Please consider these terms carefully when booking.`,
  },
  {
    question: 
      "5. Is there any financial assistance or are scholarships available?",
    answer:
      "Yes! We offer partial scholarships and flexible payment plans because we want everyone to be able to attend, regardless of financial circumstances. If you’re interested, please contact us at <a href='mailto:retreats@geneenroth.com'>retreats@geneenroth.com</a> to discuss options or apply for a scholarship.",
  },
  {
    question: 
      "6. How will the retreat be broadcast?",
    answer:
      "Our retreat will be hosted live via Zoom. If you’re not familiar with it, don’t worry—we’ll be happy to guide you through a test session to ensure you feel completely confident before the retreat begins.",
  },
  {
    question: 
      "7. What type of equipment do I need?",
    answer: 
      `Any device that connects to the internet will work—whether it’s a desktop computer, laptop, or tablet/iPad. For the best experience, we recommend a connection speed of at least 2.0 Mbps. You can easily check your internet speed at <a href='https://fast.com'>https://fast.com</a>.`,
  },
  {
    question: 
      "8. What if I experience technical difficulties during the retreat?",
    answer: 
      `We’ve got you covered! Our support team will be available by phone or text throughout the online retreat, so if any technical hiccups come up, help is just a message away.`,
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(Array(faqs.length).fill(false));

  const toggle = (i) =>
    setOpen((prev) => prev.map((v, idx) => (idx === i ? !v : v)));

  return (
    <section className="px-[10%] bg-white my-[30px]">
      <h2 className="text-[30px] text-left font-century">
        Your Questions, Answered: How We Support&nbsp;You
      </h2>
      {faqs.map((item, idx) => (
        <div
          key={idx}
          onClick={() => toggle(idx)}
          className="my-5 cursor-pointer select-none"
        >
          <h3 className="flex items-start justify-between text-[20px] text-left font-century font-bold">
            {item.question}
            <motion.span
              animate={{ rotate: open[idx] ? 45 : 0 }}
              transition={{ duration: 0.2 }}
              className="ml-2 text-[24px] leading-none"
            >
              {open[idx] ? "×" : "+"}
            </motion.span>
          </h3>
          <AnimatePresence initial={false}>
            {open[idx] && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="overflow-hidden text-[17px] text-left font-roboto max-w-none"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(item.answer),
                }}
              />
            )}
          </AnimatePresence>
        </div>
      ))}
    </section>
  );
}
